<!--
/**
 * APCWO customisation for OrangeHRM — Event Notifications module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        Add Event Notification
      </oxd-text>
      <oxd-divider />
      <event-notification-form
        :loading="isLoading"
        submit-label="Save"
        @submit="onSave"
        @cancel="onCancel"
      />
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@ohrm/core/util/services/api.service';
import EventNotificationForm from '../components/EventNotificationForm.vue';

export default {
  name: 'SaveEventNotification',
  components: {
    'event-notification-form': EventNotificationForm,
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/apcwo/event-notifications',
    );
    return {http};
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    onSave(payload) {
      this.isLoading = true;
      this.http
        .create(payload)
        .then(() => this.$toast.saveSuccess())
        .then(() => this.onCancel())
        .catch((e) => {
          const message = e?.response?.data?.error?.message;
          if (message) {
            this.$toast.error({title: 'Error', message});
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onCancel() {
      navigate('/admin/viewEventNotifications');
    },
  },
};
</script>
